<template>
  <div class="headline">
    <h2 class="text">{{ content }}</h2>
  </div>
</template>

<style lang="scss" scoped>
.headline {
  text-align: center;

  .text {
    font-family: $font-family-lautstark;
    color: $color-text;
    font-size: $font-size-headline-mobile;
    font-weight: $font-weight-smallest;
    margin: $spacing-m;
    line-height: $font-line-height-headline-mobile !important;

    @media (min-width: 1024px) {
      font-size: $font-size-headline;
      line-height: $font-line-height-headline !important;
      margin: $spacing-xl;
    }
  }
}
</style>
<script>
export default {
  name: "Headline",
  props: {
    content: String,
  },
};
</script>
